module.exports = __webpack_public_path__ + "static/media/DrillingService.09984d51.png";